import styled from "styled-components";
import { buildPaddingDeclarations, buildBackgroundDeclarations, buildBorderDeclarations, buildAfterDeclarations, buildBeforeDeclarations, } from "./declarations";
import { getColor, getTabTitleHeight, isWithBackground } from "./utils";
export const TabContainer = styled.li `
  &&& {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    box-sizing: border-box;
    list-style: none;

    ${({ disabled }) => `cursor: ${disabled ? "default" : "pointer"};`}
    height: ${getTabTitleHeight};

    ${({ alignment }) => `width: ${alignment === "horizontal" ? "auto" : "100%"};`}
    ${({ alignment }) => `margin-right: ${alignment === "horizontal" ? "1rem" : "0"};`}
    ${({ stylingType }) => `margin-bottom: ${isWithBackground(stylingType) ? "2px" : "0rem"};`}
    ${({ stylingType }) => `margin-top: ${isWithBackground(stylingType) ? "2px" : "0rem"};`}

    ${buildPaddingDeclarations}
    ${buildBackgroundDeclarations}
    ${buildBorderDeclarations}
    ${getColor}

    @media ${({ theme }) => theme.device.touch} {
      height: ${(props) => getTabTitleHeight(Object.assign(Object.assign({}, props), { touchScreen: true }))};
    }

    &::before {
      box-sizing: border-box;
      height: calc(100% + 2px);
      content: "";
      width: 6px;
      position: absolute;
      left: -1px;
      ${(props) => {
    return buildBeforeDeclarations(Object.assign(Object.assign({}, props), { hovered: props.isLastHovered }));
}}
    }

    &::after {
      box-sizing: border-box;
      width: calc(100% + 2px);
      content: "";
      position: absolute;
      left: -1px;
      ${(props) => {
    return buildAfterDeclarations(Object.assign(Object.assign({}, props), { hovered: props.isLastHovered }));
}}
    }

    @media (hover: hover) {
      &:hover {
        ${(props) => {
    return buildBorderDeclarations(Object.assign(Object.assign({}, props), { hovered: true }));
}}
        ${(props) => {
    return buildBackgroundDeclarations(Object.assign(Object.assign({}, props), { hovered: true }));
}}
        &::before {
          ${({ focused }) => (focused ? "z-index: -1;" : "")}
          ${(props) => {
    return buildBeforeDeclarations(Object.assign(Object.assign({}, props), { hovered: true }));
}}
        }

        &::after {
          ${({ focused }) => (focused ? "z-index: -1;" : "")}
          ${(props) => {
    return buildAfterDeclarations(Object.assign(Object.assign({}, props), { hovered: true }));
}}
        }
      }
    }

    &:focus {
      ${(props) => {
    return buildBorderDeclarations(Object.assign(Object.assign({}, props), { focus: true }));
}}
      ${getColor}
    }

    &:active {
      ${({ theme }) => theme.global.disableTapHighlight}
      ${(props) => {
    return buildBackgroundDeclarations(Object.assign(Object.assign({}, props), { active: true }));
}}
      ${(props) => buildBorderDeclarations(Object.assign(Object.assign({}, props), { active: true }))}
      ${(props) => getColor(Object.assign(Object.assign({}, props), { active: true }))}

      & div[data-gdds-avatar='true'] {
        button {
          color: ${({ theme }) => theme.colors.white};
          > div {
            border: 1px solid ${({ theme }) => theme.colors.white};
          }
          img {
            border: 1px solid ${({ theme }) => theme.colors.grey15};
          }

          svg {
            fill: ${({ theme }) => theme.colors.white};
          }
        }
      }

      &::after {
        ${(props) => {
    return buildAfterDeclarations(Object.assign(Object.assign({}, props), { active: true }));
}}
      }
      &::before {
        ${(props) => {
    return buildBeforeDeclarations(Object.assign(Object.assign({}, props), { active: true }));
}}
      }

      & div > span > svg {
        ${({ alignment, disabled, stylingType, theme }) => alignment === "horizontal" ||
    disabled ||
    isWithBackground(stylingType)
    ? `fill: ${theme.colors.grey15};`
    : `fill: ${theme.colors.white};`}
      }
    }

    & div > div {
      ${({ stylingType }) => stylingType === "withAdditionalElement"
    ? `white-space: nowrap; text-overflow: ellipsis; overflow: hidden;`
    : ""}
    }

    & div[data-gdds-avatar="true"] {
      &:hover {
        cursor: pointer;
      }
      button {
        &:focus {
          border: none;
          outline: none;
        }
        &:hover {
          background-color: transparent;
        }
        > div {
          border: 0.0625rem solid
            rgba(${({ theme }) => theme.colors.transparentBlack}, 0.2);
          &:hover > label {
            cursor: pointer;
          }
          img {
            &:hover {
              img {
                border: 0.0625rem solid
                  rgba(${({ theme }) => theme.colors.transparentBlack}, 0);
              }
            }
          }
        }
      }
    }

    & div > span > svg {
      ${({ disabled, stylingType, theme }) => stylingType === "withAdditionalElement" && disabled
    ? `fill: ${theme.colors.grey09};`
    : ""}
    }
  }
`;
